import React, {Component} from 'react';
import {Avatar} from '@material-ui/core';
import PropTypes from "prop-types";
import {UecareLightBox} from "./";


class UecareUploadAvatar extends Component {

    static propTypes = {
        className: PropTypes.any,
        saveNewImage: PropTypes.func,
        src: PropTypes.string,
        alt: PropTypes.string,
        canChangeAvatar: PropTypes.bool,
    };

    // setting props default value
    static defaultProps = {
        canChangeAvatar: true
    };

    state = {
        base64Image: null
    };

    constructor(props) {
        super(props);
        this.handleFileSelect = this.handleFileSelect.bind(this); // 讓 handleFileSelect 中的 this.refs 不會 undefined
    }

    handleFileSelect(e) {
        e.preventDefault();
        this.refs.fileUploader.click();
    }

    getFileSize = (file) => {
        return file.size;
    };

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    };

    handleFileChange = async (controller) => {
        try {
            const uploadFile = this.refs.fileUploader.files[0];
            if (this.getFileSize(uploadFile) / 1024 / 1024 > 5) throw new Error('上傳圖片不能超過 5 MB');
            const base64Image = await this.getBase64(this.refs.fileUploader.files[0]);
            this.setState({base64Image});
        } catch (err) {
            console.error(err);
        }
    };

    async saveNewImage() {

        if (this.state.base64Image && this.props.saveNewImage) {
            await this.props.saveNewImage(this.state.base64Image);
        }
    }

    render() {

        const imageSrc = this.state.base64Image || this.props.src;

        return (
            <div>
                <UecareLightBox ref={ref => this.uecareLightBox = ref}
                                images={[{src: imageSrc}]}
                                showImageCount={false}
                                onClickImage={(this.props.canChangeAvatar) ? this.handleFileSelect : undefined}
                                onClose={this.saveNewImage.bind(this)}/>
                <input type="file" id="fileUploader" ref="fileUploader"
                       onChange={this.handleFileChange} style={{display: "none"}}/>
                <Avatar onClick={(e) => this.uecareLightBox.openLightbox(0, e)}
                        className={this.props.className}
                        alt={this.props.alt}
                        src={imageSrc}/>
            </div>
        );
    }
}

export default UecareUploadAvatar;



// WEBPACK FOOTER //
// ./src/components/UecareUploadAvatar.js